import { clientEnv } from '@/env';
import { localizeHref } from '@/paraglide/runtime';

const siteUrl = clientEnv.siteUrl.replace(/\/$/, '');

export const hreflangLinks = (canonicalPath: string) => [
  {
    rel: 'alternate',
    hrefLang: 'en',
    href: `${siteUrl}${localizeHref(canonicalPath, { locale: 'en' })}`,
  },
  {
    rel: 'alternate',
    hrefLang: 'es',
    href: `${siteUrl}${localizeHref(canonicalPath, { locale: 'es' })}`,
  },
  {
    rel: 'alternate',
    hrefLang: 'x-default',
    href: `${siteUrl}${localizeHref(canonicalPath, { locale: 'en' })}`,
  },
];

const SITE_URL = 'https://www.listening.com';

function toAbsoluteUrl(path: string): string {
  if (/^https?:\/\//.test(path)) return path;
  return `${SITE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
}

export const seo = ({
  title,
  description,
  keywords,
  image = '/social-og-image.png',
  ogType = 'website',
}: {
  title: string;
  description?: string;
  image?: string;
  keywords?: string;
  ogType?: string;
}) => {
  const absoluteImage = image ? toAbsoluteUrl(image) : undefined;
  const tags = [
    { title },
    { name: 'description', content: description },
    ...(keywords ? [{ name: 'keywords', content: keywords }] : []),
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:card', content: 'summary_large_image' },
    { property: 'og:type', content: ogType },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    ...(absoluteImage
      ? [
          { name: 'twitter:image', content: absoluteImage },
          { property: 'og:image', content: absoluteImage },
        ]
      : []),
  ];
  return tags;
};

export type CookieTrackers = Array<
  React.DetailedHTMLProps<
    React.ScriptHTMLAttributes<HTMLScriptElement>,
    HTMLScriptElement
  >
>;

export const strToInlineScript = (str: string) => ({
  children: str,
});
